import { render, staticRenderFns } from "./DiscountNavigation.vue?vue&type=template&id=6812b3dd&scoped=true"
import script from "./DiscountNavigation.vue?vue&type=script&lang=js"
export * from "./DiscountNavigation.vue?vue&type=script&lang=js"
import style0 from "./DiscountNavigation.vue?vue&type=style&index=0&id=6812b3dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812b3dd",
  null
  
)

export default component.exports